'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconMagnifyingGlass, iconMagnifyingGlassTag } from '@ni/nimble-components/dist/esm/icons/magnifying-glass';
import { wrap } from '../../utilities/react-wrapper';

export type { IconMagnifyingGlass };
export { iconMagnifyingGlassTag };
export const NimbleIconMagnifyingGlass = wrap(IconMagnifyingGlass);